export default __webpack_public_path__ + "static/media/pms.e6409d13.png";